import TiltCard from "@/components/base/TiltCard";

const steps = [
  {
    num: "01",
    title: "Tell me what's up",
    body: "A short message or booking form — a couple of photos help a lot.",
    icon: "ri-message-3-line",
  },
  {
    num: "02",
    title: "Pick a time",
    body: "Choose an appointment slot that works for you, usually same-week.",
    icon: "ri-calendar-check-line",
  },
  {
    num: "03",
    title: "Job done, tidy",
    body: "Clear pricing before I start, safe work, and everything left neat.",
    icon: "ri-shield-check-line",
  },
];

export default function HowItWorks() {
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-4">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            How it works
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05]">
            Three simple steps<br />
            <em className="not-italic text-accent-600">to a fixed problem.</em>
          </h2>
          <p className="mt-4 text-foreground-600 max-w-md">
            Booking a local electrician shouldn't feel like a chore. Here's what
            happens after you get in touch.
          </p>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {steps.map((s) => (
            <TiltCard key={s.num} className="rounded-2xl" rotation={8} scale={1.02}>
            <div
              className="group relative flex flex-col p-6 rounded-2xl bg-background-100 border border-background-200 hover:border-accent-500 transition-colors duration-300 h-full"
            >
              <div className="flex items-center justify-between">
                <span className="text-4xl md:text-5xl font-heading font-semibold text-accent-600 tracking-tight">
                  {s.num}
                </span>
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-950 text-background-50 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors">
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              </div>
              <h3 className="mt-8 text-xl font-heading font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {s.body}
              </p>
            </div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
}